import { Field, Form } from "react-final-form";
import { FormContainer, InputContainer, MainContainer } from "./styles";
import React, { Component } from "react";

import Button from "Components/Button";
import { Fonts } from "Themes";
import FormInput from "Components/FormInput/FormInput";
import FormTextArea from "Components/FormTextArea";

const validate = (values) => {
  const errors = {};
  if (!values.projectName) {
    errors.projectName = "Required";
  }
  if (!values.projectDescription) {
    errors.projectDescription = "Required";
  }
  return errors;
};

class CreateProjectForm extends Component {
  render() {
    const { handleSubmit } = this.props;
    return (
      <Form
        onSubmit={handleSubmit}
        validate={validate}
        render={({ handleSubmit }) => (
          <FormContainer onSubmit={handleSubmit}>
            <MainContainer>
              <InputContainer>
                <Field
                  name={"projectName"}
                  render={(props) => {
                    return (
                      <FormInput
                        {...props}
                        placeholder={"Project Name"}
                        style={{
                          border: "solid 2px lightgray",
                          borderRadius: 10,
                          fontSize: `${Fonts.fontSize.large}px`,
                        }}
                      />
                    );
                  }}
                />
              </InputContainer>
              <InputContainer>
                <Field
                  name={"projectDescription"}
                  render={(props) => {
                    return (
                      <FormTextArea
                        {...props}
                        placeholder={"Describe your project..."}
                        resize="none"
                        style={{
                          fontSize: Fonts.fontSize.medium,
                          border: "solid 2px lightgray",
                          borderRadius: 10,
                        }}
                      />
                    );
                  }}
                />
              </InputContainer>
              <div
                style={{
                  marginTop: 20,
                  height: 100,
                  width: "50%",
                  float: "right"
                }}
              >
                <Button type={"submit"}>Create Project</Button>
              </div>
            </MainContainer>
          </FormContainer>
        )}
      />
    );
  }
}

export default CreateProjectForm;
